module.exports = __webpack_public_path__ + "static/media/galerija_2023 (10).67b3eb86.jpg";